import { I18nLang } from '@/language/language.model';

export function convertLocaleToReplyLang(locale) {
	const langMap = {
		[I18nLang.English]: 'en',
		[I18nLang.Spanish]: 'es',
		[I18nLang.繁體中文]: 'zh-TW',
		[I18nLang.简体中文]: 'zh_CN',
		[I18nLang.日本語]: 'ja',
		[I18nLang.한국어]: 'ko',
		[I18nLang.Vietnamese]: 'vi',
	};

	return langMap[locale] || 'en';
}

export function convertLocaleToSpeechLang(locale) {
	const langMap = {
		[I18nLang.English]: 'en-US',
		[I18nLang.Spanish]: 'es-ES',
		[I18nLang.繁體中文]: 'cmn-Hant-TW',
		[I18nLang.简体中文]: 'cmn-Hant-TW',
		[I18nLang.日本語]: 'ja-JP',
		[I18nLang.한국어]: 'ko-KR',
		[I18nLang.Vietnamese]: 'vi-VN',
	};

	return langMap[locale] || 'en-US';
}
export function convertLangToAuthModuleLocale(locale) {
	const langMap = {
		[I18nLang.English]: 'en',
		[I18nLang.Spanish]: 'es',
		[I18nLang.繁體中文]: 'tc',
		[I18nLang.简体中文]: 'sc',
		[I18nLang.日本語]: 'jp',
		[I18nLang.한국어]: 'kr',
		[I18nLang.Vietnamese]: 'vn',
	};

	return langMap[locale] || 'en';
}